export default {
  ACCOUNTS: "Accounts",
  VIEW_ELIXIO_CONNECT: "Synchronization",
  ADD_ELIXIO_CONNECT_SERVICE: "Add a service",
  ADD_ELIXIO_CONNECT_CONFIGURE_THIS_SERVICE: "Configure",
  ELIXIO_CONNECT_SUBMIT: "Submit",
  ELIXIO_CONNECT_TEST_CONFIG: "Test Configurations",
  ELIXIO_CONNECT_PROD_CONFIG: "Production Configurations",
  ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION: "Confirm this action?",
  ELIXIO_ADDITIONNAL_CONFIG_TITLE: "Additional Configuration",
  ELIXIO_START_CONNECT: "Start",
  ELIXIO_PENDING_CONNECT: "Update in progress...",
  ELIXIO_STOP_CONNECT: "Stop",
  ELIXIO_TAB_DATA_TITLE: "Synchronize existing data",
  ELIXIO_TAB_CONFIG: "Configuration",
  ELIXIO_TAB_UPDATE_DATA: "Synchronize existing data",
  ELIXIO_CONNECT_STATUS_PENDING: "In progress",
  ELIXIO_CONNECT_STATUS_DONE: "Completed",
  ELIXIO_UPDATED_INVOICES: "Synchronizing invoices",
  ELIXIO_UPDATED_PAYMENTS: "Synchronizing payments",
  ELIXIO_UPDATED_CUSTOMERS: "Synchronizing customers",
  ELIXIO_CONNECT_COMPLETED: "Synchronization completed",
  ELIXIO_CONNECT_CANCELLED: "Synchronization canceled",
  ELIXIO_CONNECT_TOTAL_PROGRESS: "Total progress",
  ELIXIO_START_IMPORT_AT: "Start from:",
  SELECT_DATE: "Select a date",
  ELIXIO_CONNECT_CONFIRM_THIS_DEACTIVATION: "Confirm this deactivation?",
  SOMETHING_WENT_WRONG: "Something went wrong",
  ELIXIO_CONNECT_CONFIRM_THIS_REACTIVATION: "Confirm this reactivation?",
  OPERATION_SUCCEEDED: "Operation succeeded",
  OPERATION_FAILED: "Operation failed",
  LOGIN_TO_YOUR_ACCOUNT: "Log in to your account",
  MODULES: "Available modules",
  LOGIN_TO: "Log in to",
  RE_LOGIN_TO: "Re-log in to",
  DEACTIVATE: "Deactivate",
  ACTIVATE: "Activate",
  REACTIVATE: "Reactivate",
  VALIDATE: "Validate",
  ACTIVE: "Active",
  CONFIGURE: "Configure",
  AUTH_FINISHED: "Authentication finished. Refreshing...",
  NOT_CONFIGURED_YET: "Not yet configured",
  SHIPMENT_STATUS_DRAFT: "Draft",
  SHIPMENT_STATUS_ESTIMATED: "Estimated",
  SHIPMENT_STATUS_CREATED: "Created",
  SHIPMENT_STATUS_PICKUP_CREATED: "Pickup created",
  SHIPMENT_STATUS_IN_TRANSIT: "In transit",
  SHIPMENT_STATUS_DELIVERED: "Delivered",
  SHIPMENT_STATUS_EXCEPTION: "Exception",
  SHIPMENT_STATUS_CANCELLED: "Cancelled",
  Sender: "Sender",
  package: "Package",
  envelope: "Envelope",
  "courier-pack": "Express Package",
  freight: "Freight",
  OutsideDoor: "Outside Door",
  FrontPorch: "Porch",
  Office: "Office",
  SideDoor: "Side Door",
  Basement: "Basement",
  FrontDesk: "Reception",
  BetweenDoors: "Between Doors",
  Security: "Security",
  Counter: "Counter",
  Lobby: "Lobby",
  Mailbox: "Mailbox",
  GateHouse: "Gatehouse",
  Desk: "Office",
  Kiosk: "Kiosk",
  Shipping: "Shipping",
  ProShop: "Pro Shop",
  FrontDoor: "Front Door",
  Receiving: "Reception",
  Reception: "Reception",
  BackDoor: "Back Door",
  Lab: "Laboratory",
  MailRoom: "Mailroom",
  Garage: "Garage",
  Pharmacy: "Pharmacy",
  ServiceCounter: "Service Counter",
  PartsDepartment: "Parts Department",
  lb: "Pounds",
  kg: "Kilograms",
  EightFiveByEleven: "8.5 x 11",
  FourBySix: "4 x 6",
};
